import React from 'react';

export const CalcField = ({ label, icon: Icon, value, onChange, suffix, step = 1, max, testid }) => (
  <label className="block">
    <span className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-2">
      <Icon className="w-4 h-4 text-[#1a5c3b]" />{label}
    </span>
    <div className="flex items-center rounded-xl border-2 border-gray-200 focus-within:border-[#1a5c3b] bg-white transition-colors">
      <input
        type="number"
        inputMode="decimal"
        min="0"
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value === '' ? '' : Math.max(0, Math.min(max ?? Infinity, Number(e.target.value))))}
        className="flex-1 min-w-0 bg-transparent px-4 py-3 text-base font-semibold text-[#0f172a] outline-none"
        data-testid={testid}
      />
      <span className="px-4 text-slate-400 font-semibold">{suffix}</span>
    </div>
  </label>
);
